import type { UserType, UserAccess } from "types/DataTypes";

export const getUserAccessConfig = (
  loggedInUser: UserType | null | undefined,
): UserAccess => {
  if (!loggedInUser) {
    return {
      can_view_section111: false,
    };
  }

  const isSuperUser = loggedInUser.is_superuser || loggedInUser.is_staff;
  const serviceOptions = loggedInUser.active_licensed_services || [];
  const hasSection111 = serviceOptions.some(
    (service) => service.value === "111",
  );

  return {
    can_view_section111:
      (loggedInUser.has_cms_authority && hasSection111) || isSuperUser,
  };
};
